import { NavLink } from 'react-router-dom';
import links from '../utils/links';

const NavLinks = ({ toggleSidebar }) => {
  return (
    <div className='nav-links'>
      {links.map((link) => {
        const { id, text, path, icon } = link;
        return (
          <NavLink
            className={({ isActive }) => {
              return isActive ? 'nav-link active' : 'nav-link';
            }}
            key={id}
            to={path}
            onClick={toggleSidebar}
          >
            <span className='icon'>
              {icon}
              {text}
            </span>
          </NavLink>
        );
      })}
    </div>
  );
};
export default NavLinks;
